import React from 'react';
import fetch from 'node-fetch';
import jsonPageData from '../../helpers/json-page-data';
import Events from '../../events/events';
import getUserEmail from './utils/getUserEmail';
import { refreshRecommendationsForPlacement, placements } from '../../helpers/recommendations';
import Recommendations from '../recommendations/Recommendations';

const { oosRecommendationsEnabled = false } = jsonPageData.getData();
const { RECOMMENDATIONS_OOS_PLACEMENT } = placements;
import { showIfSizeSelectionHasErrors } from '../size-selection-errors';

class EmailMeForm extends React.Component {
  constructor(props) {
    super(props);

    const { type } = this.props;
    const launchProduct = (type === 'launch');

    this.state = {
      formState: 'default',
      formURL: this.getFormURL(launchProduct),
      launchProduct,
      userEmail: getUserEmail(),
      errorType: '',
    };

    this.generateErrorMessage.bind(this);
    this.handleInputChange.bind(this);
    this.handleButtonClick.bind(this);
  }

  componentDidMount() {
    if (oosRecommendationsEnabled) {
      refreshRecommendationsForPlacement(RECOMMENDATIONS_OOS_PLACEMENT)
    }
  }

  componentDidUpdate(prevProps) {
    const resetForm = (prevProps.skuId !== this.props.skuId || prevProps.shouldSelectSize !== this.props.shouldSelectSize);

    if (resetForm) {
      this.setState({
        formState: 'default',
        errorType: ''
      });
    }
  }

  getFormURL(launchProduct) {
    const stockURL = '/notifications/stock/emails';
    const launchURL = '/notifications/product-launch/emails';

    return launchProduct ? launchURL : stockURL;
  }

  generateErrorMessage() {
    switch(this.state.errorType) {
    case 'empty':
      return 'Please enter an email address';
    case 'sizeSelection':
      return 'Please select a size first';
    case 'server':
      return 'Sorry, we\'ve had a technical problem - please try again later';
    default:
      return 'Please enter a valid email address';
    }
  }

  handleInputChange(e) {
    this.setState({
      userEmail: e.target.value,
      formState: 'default',
      errorType: ''
    });
  }

  triggerNewrelicEvent (action, data){
    window.newrelic = window.newrelic || undefined;
    const asyncTriggerNewrelicEvent = async (action, data = {}) => {
      if(window.newrelic) window.newrelic.addPageAction(`oos-actual-button:${action}`, data);
    }
    asyncTriggerNewrelicEvent(action, data);
  }

  handleButtonClick(e, skuId, productId, notifyNewlyInStock) {
    e.preventDefault();
    const sizeSelected = document.querySelector('input[name="sizeNotSelected"]');
    if(sizeSelected) {
      showIfSizeSelectionHasErrors()
      return;
    }
    const { formState, formURL, userEmail: email, launchProduct  } = this.state;
    const { shouldSelectSize, sizeErrorSetter, closeModal } = this.props;

    const requestURL = `${formURL}?email=${email}&skuId=${skuId}&productId=${productId}&newlyInStock=${notifyNewlyInStock}`;
    const successResponse = 200;
    const analyticsAction = launchProduct ? 'global.nmwplSubmitted' : 'global.emwbisSubmitted';

    if (closeModal && formState === 'submitted') {
      return closeModal(e);
    }

    if (shouldSelectSize) {
      this.setState({
        formState: 'error',
        errorType: 'sizeSelection'
      });

      return sizeErrorSetter();
    }

    if (email.length < 1) {
      this.setState({
        formState: 'error',
        errorType: 'empty'
      });
      return;
    }

    if (!email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) {
      this.setState({
        formState: 'error',
        errorType: 'email'
      });
      return;
    }

    this.setState({formState: 'submitting'});

    fetch(requestURL, {
      method: 'POST',
    }).then(response => {
      if(response.status === successResponse) {
        if(closeModal){
          document.body.dispatchEvent(
            new CustomEvent('dataStateChange', {
              detail: { action: 'plp.quickViewEmail' }
            })
          );
          Events.quickViewEmailMeDone.trigger(window, {
            skuId,
            productId
          });
        } else {
          document.body.dispatchEvent(
            new CustomEvent('dataStateChange', {
              detail: { action: analyticsAction }
            })
          );
        }
        this.triggerNewrelicEvent('email-me-when-available-button');
        this.setState({
          formState: 'submitted',
          userEmail: ''
        });
      } else {
        this.setState({formState: 'error', errorType: 'server'});
      }
    });
  }

  render() {
    const { productId, skuId, releaseDate, closeModal, notifyNewlyInStock } = this.props;
    const { formState, errorType, userEmail, launchProduct } = this.state;
    const rootClass = 'email-me-stock';

    let sectionClasses = rootClass;
    let formClasses = `${rootClass}__form`;
    if(launchProduct && formState !== 'submitted') {
      sectionClasses = `${sectionClasses} ${rootClass}--no-footer`;
      formClasses = `${formClasses} ${rootClass}__form--no-title`;
    }
    if(releaseDate && formState !== 'submitted') {
      sectionClasses = `${sectionClasses} ${rootClass}--seperate-title`
      formClasses = `${formClasses} ${rootClass}__form--seperated`;
    }
    const titleClasses = releaseDate ? `${rootClass}__header ${rootClass}__header--seperated` : `${rootClass}__header`;
    const titleText = launchProduct ? (releaseDate ? `Available ${releaseDate}` : '') : `Out of stock online`;
    const footerClasses = `${rootClass}__text`;
    const footerText = launchProduct ? '' : `We'll also share some similar product recommendations. If the item does not come back in stock we will notify you.`;
    const inputName = `${skuId}-email`;
    const labelText = launchProduct ? 'Email me when available' : 'Email me when back in stock';
    const labelClasses = `${rootClass}__label`;
    const inputId = 'stockNotificationEmail';
    const inputClasses = (formState === 'error' &&  errorType !== 'sizeSelection') ? `${rootClass}__input ${rootClass}__input--error` : `${rootClass}__input`;
    const buttonText = (formState !== 'submitted') ? 'Notify me' : 'Continue shopping';
    const buttonDisabled = (formState !== 'default');
    const activeButtonClass = (formState === 'error') ? `${rootClass}__button ${rootClass}__button--disabled` : (formState === 'submitting') ? `${rootClass}__button ${rootClass}__button--submitting u-button-loader` : `${rootClass}__button`;
    const inactiveButtonClass = (closeModal) ? `${rootClass}__button` : `${rootClass}__button--hidden`;
    const errorClasses = `${rootClass}__error`;
    const conformationClass = `${rootClass}__confirmation`;
    const conformationTitleClasses = `${conformationClass} ${conformationClass}--title`;
    const isJoyfullyBold = document.querySelector('[data-test="joyfullyBold"]') !== null;
    return (
      <section className={sectionClasses}>
        {formState !== 'submitted' ?
          [
            <h2 className={titleClasses}>{titleText}</h2>,
            <form className={formClasses} action={this.state.formURL} method="POST" noValidate="novalidate">
              <label className={labelClasses} htmlFor={inputName}>{labelText}</label>
              <input
                className={inputClasses}
                type="email"
                name={inputName}
                id={inputId}
                maxLength="40"
                onChange={e => this.handleInputChange(e)}
                value={userEmail}
              />

              {(formState === 'error' && errorType !== 'sizeSelection') && <span className={errorClasses}>{this.generateErrorMessage()}</span>}

              <input name="productId" value={productId} type="hidden" />
              <input name="skuId" value={skuId} type="hidden" />
              <input name="isRomanBlind" value="false" type="hidden" />
              <input name="notifyNewlyInStock" value={notifyNewlyInStock} type="hidden" />
              <button className={activeButtonClass} type="submit" disabled={buttonDisabled} onClick={e => this.handleButtonClick(e, skuId, productId, notifyNewlyInStock)}>
                {buttonText}
              </button>
            </form>,
            <p className={footerClasses}>{footerText}</p>
          ]
          :
          [
            <p className={conformationTitleClasses}>We’ve just sent you a confirmation email</p>,
            <p className={conformationClass}>We’ll contact you when this product becomes available.</p>,
            <button className={inactiveButtonClass} onClick={e => this.handleButtonClick(e)}>
              {buttonText}
            </button>
          ]
        }
        {oosRecommendationsEnabled &&
          <Recommendations
            productId={productId}
            maxProductsPerPage={3}
            type="small"
            allowRefresh
            autoLoad={false}
            placement={RECOMMENDATIONS_OOS_PLACEMENT}
            skuId={skuId}
            isJoyfullyBold={isJoyfullyBold}
          />
        }
      </section>
    );
  }
}

export default EmailMeForm;
